// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Functor_Contravariant_Compat from "../Data.Functor.Contravariant.Compat/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Specular_Callback from "../Specular.Callback/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
var elem = /* #__PURE__ */ Data_Foldable.elem(Data_Foldable.foldableArray);
var contramapCallbackDyn = /* #__PURE__ */ Specular_Callback.contramapCallbackDyn();
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic);
var refUpdate = /* #__PURE__ */ Specular_Ref.refUpdate(Effect_Class.monadEffectEffect);
var map = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var refUpdateConst = /* #__PURE__ */ Specular_Ref.refUpdateConst(Effect_Class.monadEffectEffect);
var ChoiceRef = function (x) {
    return x;
};
var makeChoiceRef = function (dictEq) {
    var elem1 = elem(dictEq);
    return function (choices_) {
        return function (ref) {
            var ensureValid = function (choices$prime) {
                return function (old) {
                    return function ($$new) {
                        if (elem1($$new)(choices$prime)) {
                            return $$new;
                        };
                        if (Data_Boolean.otherwise) {
                            return old;
                        };
                        throw new Error("Failed pattern match at Specular.ChoiceRef (line 41, column 5 - line 43, column 24): " + [ choices$prime.constructor.name, old.constructor.name, $$new.constructor.name ]);
                    };
                };
            };
            return {
                choices: choices_,
                currentChoice: new Specular_Ref.Ref(Specular_Ref.refValue(ref), contramapCallbackDyn(mapFlipped(choices_)(function (choices$prime) {
                    return function (updateFn) {
                        return function (old) {
                            return ensureValid(choices$prime)(old)(updateFn(old));
                        };
                    };
                }))(refUpdate(ref)))
            };
        };
    };
};
var newChoiceRef = function (dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var bind = Control_Bind.bind(Monad0.Bind1());
    var newRef = Specular_Ref.newRef(dictMonadEffect);
    var pure = Control_Applicative.pure(Monad0.Applicative0());
    return function (dictEq) {
        var makeChoiceRef1 = makeChoiceRef(dictEq);
        return function (choices_) {
            return function (initial) {
                return bind(newRef(initial))(function (ref) {
                    return pure(makeChoiceRef1(choices_)(ref));
                });
            };
        };
    };
};
var currentChoice = function (v) {
    return v.currentChoice;
};
var choices = function (v) {
    return v.choices;
};
var withSelectionStatus = function (dictEq) {
    var eq = Data_Eq.eq(dictEq);
    return function (cref) {
        return map(map1(function (x) {
            return {
                value: x,
                selected: map(eq(x))(Specular_Ref.refValue(currentChoice(cref))),
                select: Data_Functor_Contravariant_Compat.cmap(function (v) {
                    return x;
                })(refUpdateConst(currentChoice(cref)))
            };
        }))(choices(cref));
    };
};
export {
    ChoiceRef,
    newChoiceRef,
    makeChoiceRef,
    choices,
    currentChoice,
    withSelectionStatus
};
